<template>
  <gg-card>
    <gg-card-header>
      About {{ starterSite.website_name }}
    </gg-card-header>
    <gg-card-text>
      <v-row>
        <v-col cols="12">
          <p>
            In a few short sentences, tell us about your business, goal(s) for your website, target audience,
            and any other information you think will be useful for building your website.
          </p>
          <v-textarea
            outlined
            class="gg-input"
            dense
            rows="4"
            v-model="about"
          />
        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'WebsiteAbout',
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      starterSite: 'wizard_model/starterSite'
    }),
    about: {
      get () {
        return this.starterSite.contentAbout
      },
      set (val) {
        this.setAbout(val)
      }
    }
  },
  methods: {
    ...mapMutations({
      setAbout: 'wizard_model/SET_SS_CONTENT_ABOUT'
    }),
    validate () {
      return true
    }
  }
}
</script>

<style scoped>

</style>
